import {
  Alert,
  Box,
  FormControl,
  Button,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Link,
  AlertTitle, Dialog, DialogTitle, DialogContent, DialogActions
} from "@mui/material";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
import Visibility from "@mui/icons-material/Visibility";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";
import toast from "react-hot-toast";
import React, { useEffect } from "react";
import { useAuthProvider } from "../../context/AuthProvider";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import HelperText from "../../components/partials/HelperText";
import { onLogin } from "../../src/utils/queries";
import { useRouter } from "next/router";
import CircleSpinner from "../../components/Spinner/Index";
import AuthLayout from "../../components/layouts/AuthLayout";

const schema = yup
  .object({
    email: yup.string().email().required(),
    password: yup
      .string()
      .required("Password is mandatory")
      .min(8, "Password must be at least 8 characters long"),
    checkbox: yup.boolean().notRequired(),
  })
  .required();

const index = () => {
  const router = useRouter();
  const [showPassword, setShowPassword] = React.useState(false);
  const [doneeError, setDoneeError] = React.useState(false);
  const { mutate, isLoading, isSuccess, error, isError, data } = onLogin();
  const [open, setOpen] = React.useState(false);

  const { clearState } = useAuthProvider()

  React.useEffect(() => {
    if (isSuccess) {
      const locale = data.data.data.user?.donee?.country;
      const verified = data.data.data.user.email_verified_at;
      const onBoarded = data.data.data.user?.donee?.is_onboarded;
      const passedStripe = data.data.data.user?.donee?.has_completed_stripe_onboarding;
      const userType = data.data.data.user?.donee?.type;
      const isDonnee = data.data.data.user.signup_type;

      if (isDonnee !== "donee") {
        setDoneeError(true);
        return;
      }

      setOpen(false);

      localStorage.setItem("userType", userType);
      localStorage.setItem("locale", JSON.stringify(locale));
      if (!verified) {
        sessionStorage.removeItem('token')
        sessionStorage.setItem('reg', data.data.data.token)
        router.push("/register/verification");
        return;
      }

      //  console.log(onBoarded, passedStripe)
      if (!onBoarded || !passedStripe) {
        sessionStorage.removeItem('token')
        sessionStorage.setItem('reg', data.data.data.token)
        router.push("/register/organization/onboarding");
        return;
      }

      if (locale) {
        sessionStorage.removeItem('reg')
        sessionStorage.setItem("token", data.data.data.token);
        router.push("/overview");
      }

    }
    if (isError) {

      if (error.response?.data?.message) {
        console.log(error)
        setOpen(true);
      }
    }
  }, [isSuccess, isError]);

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    watch,
  } = useForm({
    defaultValues: {
      password: "",
      email: "",
      checkbox: false,
    },
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const password = watch("password");
  const email = watch("email");

  useEffect(() => {
    setDoneeError(false);
  }, [password, email]);

  const onSubmit = ({ password, email, checkbox }) => {
    // if(checkbox){
    //   localStorage.setItem('email', email)
    // localStorage.setItem('password', password)
    // }
    mutate({ email, password });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Typography
        component={"h2"}
        variant="h2"
        textAlign={"center"}
        fontWeight={600}
        marginBottom="2em"
      >
        Login
      </Typography>
      <Box
        sx={{
          paddingX: {
            xs: "2.5em",
            sm: "4em",
            md: "4em",
          },
        }}
        bgcolor={"white"}
        maxWidth={"30rem"}
        width={"90%"}
        paddingY="4em"
        borderRadius={"16px"}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Typography variant="big" component={"p"} fontWeight="500">
            Email Address
          </Typography>
          <Controller
            name="email"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                onChange={onChange}
                size="small"
                helperText={
                  errors.email && <HelperText text={errors.email.message} />
                }
                value={value}
                fullWidth
                error={errors.email}
                sx={{
                  border: "none",
                  borderColor: "",
                  fontSize: "14px",
                  marginBottom: "2em",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "grey.border40",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "primary.main",
                    },
                  },
                }}
              // InputProps={{
              //   endAdornment: !errors.email && (
              //     <InputAdornment position="end">
              //       <IconButton
              //         aria-label="email format is good"
              //         edge="end"
              //         color="success"
              //       >
              //         <TaskAltRoundedIcon />
              //       </IconButton>
              //     </InputAdornment>
              //   ),
              // }}
              />
            )}
          />
          <Typography variant="big" component={"p"} fontWeight="500">
            Password
          </Typography>
          <Controller
            name="password"
            control={control}
            render={({ field: { onChange, value } }) => (
              <TextField
                placeholder="password"
                error={errors.password}
                helperText={
                  errors.password ? (
                    <HelperText text={errors.password.message} />
                  ) :
                    isError ? (
                      (typeof error.response?.data?.message === 'string') ? (
                        <HelperText text={error.response?.data?.message} />
                      ) : (
                        <Dialog open={open} onClose={handleClose}>
                          <DialogTitle>{error.response?.data?.message[0]}</DialogTitle>
                          <DialogContent>
                            <Box display="flex" alignItems="center" gap={1}>
                              <ErrorOutlineIcon color="error" />
                              <Typography color="error" variant="body1">
                                {error.response?.data?.message[1]}
                              </Typography>
                            </Box>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleClose}>Dismiss</Button>
                          </DialogActions>
                        </Dialog>
                      )

                    ) : null
                }
                sx={{
                  border: "none",
                  borderColor: "",
                  fontSize: "14px",
                  marginBottom: "0.5em",
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "grey.border40",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "primary.main",
                    },
                  },
                }}
                type={showPassword ? "text" : "password"}
                value={value}
                size="small"
                onChange={onChange}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword(!showPassword)}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
          {doneeError && (
            <Typography variant="small" color={"error"} textAlign="center">
              You are not authorized to access this platform
            </Typography>
          )}

          <Box
            display="flex"
            justifyContent={"space-between"}
            alignItems="center"
            mb="2.2em"
          >
            <FormGroup sx={{ fontSize: "14px" }}>
              <Controller
                name="checkbox"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <FormControlLabel
                    sx={{
                      fontSize: "14px",
                      color: "grey.light",
                      pt: "0.4em",
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px",
                      },
                      "& svg": {
                        fontSize: "1.2rem",
                      },
                    }}
                    control={<Checkbox onChange={onChange} checked={value} />}
                    label={"Remember Me"}
                  />
                )}
              />
            </FormGroup>
            <Link
              href="/reset"
              variant="big"
              style={{ textDecoration: "none", marginTop: "0.4em" }}
            >
              Forgot password?
            </Link>
          </Box>
          <Button
            fullWidth
            disabled={!isValid || isLoading}
            type="submit"
            sx={{
              borderRadius: "8px",
              paddingY: "8px",
              paddingX: "12px",
              fontSize: "14px",
              fontWeight: "600",
              textTransform: "none",
              "&.Mui-disabled": {
                opacity: "0.3",
                backgroundColor: "primary.main",
                color: "white",
              },
            }}
            variant="contained"
            color="primary"
            disableElevation
            disableFocusRipple
            disableRipple
          >
            {!isLoading ? " Login" : <CircleSpinner />}
          </Button>
        </form>
      </Box>
    </>
  );
};

index.getLayout = function getLayout(page) {
  return <AuthLayout>{page}</AuthLayout>
};

export default index;
